import CMSCategoryGridPage from "./CMSCategoryGridPage";

export default CMSCategoryGridPage;
